export const getCurrentSchedule = (props) => {
  let prefLangCode, schObj, flag = false;
  let guestSelectedLang = localStorage.getItem('GuestPreferedLang');

  if (guestSelectedLang) {
    prefLangCode = guestSelectedLang;
  } else if (props.guestLanguages) {
    //console.log("preferd lang",props.guestLanguages)
    prefLangCode = props.guestLanguages;
  } else if (props.hotelLanguage.preferredLanguageCode) {
    prefLangCode = props.hotelLanguage.preferredLanguageCode;
  }
  if (props.hotelLanguage.languages) {
    props.hotelLanguage.languages.map((iterator) => {
      // console.log('iterator',iterator)
      if (prefLangCode === iterator.languageCode) {
        // console.log('props.hotelLanguage.languages that part run', prefLangCode, iterator.languageCode)
        if (
          props.schedules[prefLangCode] &&
          props.schedules[prefLangCode].length
        ) {
          //console.log("props.schedules[prefLangCode]")
          flag = true;
          schObj = {
            schedules: props.schedules[prefLangCode],
            language: prefLangCode
          }
        } else if (
          props.defaultLayouts[prefLangCode] &&
          props.defaultLayouts[prefLangCode].length
        ) {
          //console.log("props.defaultLayouts[prefLangCode]")
          flag = true
          schObj = {
            schedules: props.defaultLayouts[prefLangCode],
            language: prefLangCode
          }
        }

        if (
          props.schedules[props.hotelLanguage.preferredLanguageCode] &&
          props.schedules[props.hotelLanguage.preferredLanguageCode].length &&
          !flag) {
          console.log("props.schedules[props.hotelLanguage.preferredLanguageCode]", props.hotelLanguage.preferredLanguageCode)
          //alert(alertText);
          flag = true
          schObj = {
            schedules: props.schedules[props.hotelLanguage.preferredLanguageCode],
            language: props.hotelLanguage.preferredLanguageCode
          }
        } else if (
          props.defaultLayouts[props.hotelLanguage.preferredLanguageCode] &&
          props.defaultLayouts[props.hotelLanguage.preferredLanguageCode].length &&
          !flag) {
          //alert(alertText);
          //console.log("props.defaultLayouts[props.hotelLanguage.preferredLanguageCode]")
          flag = true
          schObj = {
            schedules: props.defaultLayouts[props.hotelLanguage.preferredLanguageCode],
            language: props.hotelLanguage.preferredLanguageCode
          }
        }

        if (!flag) {
          //console.log("flag")
          //update this on
          schObj = {
            schedules: props.defaultLayouts["en"],
            language: "en"
          }
        }
      }
    })
  }
  // console.log("schedules", schObj);
  return schObj ? schObj : {}
}

export const getIndexOfDay = (day) => {
  // console.log('day', day)
  switch (day.toLowerCase()) {
    case 'sunday': return 1;
    case 'monday': return 2;
    case 'tuesday': return 3;
    case 'wednesday': return 4;
    case 'thursday': return 5;
    case 'friday': return 6;
    case 'saturday': return 7;
  }
}

export const getLayout = (props, schObj, reload) => {
  //console.log("get Layout", schObj)
  let schStartT, schEndT, serverTime, schedule, schStartD, schEndD
  let flag = false, currentDuration, durationId, layoutId;
  if (props.serverTime && schObj.schedules) {

    // TEST TIME OBEJT
    // let t = {
    //   "minutes": 33,
    //   "seconds": 9,
    //   "hours": 21
    // }
    // if(reload){
    //   serverTime = (t.hours * 60) +
    //   t.minutes;    
    // } else
    serverTime = (props.serverTime.hours * 60) +
      props.serverTime.minutes;
    //console.log("serverTime",serverTime,props.serverTime);
    schObj.schedules.map((iterator) => {
      schStartT = (parseInt(iterator.startTime.slice(0, 2)) * 60) +
        parseInt(iterator.startTime.slice(3, 5));
      schEndT = (parseInt(iterator.endTime.slice(0, 2)) * 60) +
        parseInt(iterator.endTime.slice(3, 5));
      schStartD = iterator.startDay
      schEndD = iterator.endDay

      //console.log("schStartT,schEndT",schStartT,schEndT);
      let existBetweenDay;
      // console.log('getIndexOfDay(schStartD) < getIndexOfDay(schEndD',getIndexOfDay(schStartD), getIndexOfDay(schEndD))
      if (getIndexOfDay(schStartD) <= getIndexOfDay(schEndD)) {
        // console.log("layout check if", getIndexOfDay(schStartD), getIndexOfDay(schEndD), getIndexOfDay(props.serverDay))
        existBetweenDay = getIndexOfDay(schStartD) <= getIndexOfDay(props.serverDay) && getIndexOfDay(schEndD) >= getIndexOfDay(props.serverDay)
      } else {
        // console.log("layout check else", getIndexOfDay(schStartD), getIndexOfDay(schEndD), getIndexOfDay(props.serverDay))
        existBetweenDay = getIndexOfDay(schStartD) >= getIndexOfDay(props.serverDay) || getIndexOfDay(schEndD) >= getIndexOfDay(props.serverDay)
      }

      // DEBUG logs
      // console.log("layoutId === durationId", getIndexOfDay(schStartD), getIndexOfDay(props.serverDay), getIndexOfDay(schEndD), getIndexOfDay(props.serverDay));
      // console.log("Schedule Codition", schStartT <= serverTime && schEndT >= serverTime && existBetweenDay,
      // schStartT <= serverTime, schEndT >= serverTime, existBetweenDay,
      // schStartT, serverTime, schEndT, serverTime, existBetweenDay)


      if (schStartT <= serverTime && schEndT >= serverTime && existBetweenDay) {
        console.log("server time match", iterator);
        flag = true;
        schedule = iterator;
      }
    })
    if (!flag) {
      schedule = props.defaultLayouts[schObj.language][0];
    }
    console.log("layoutId === durationId", getIndexOfDay(schStartD), getIndexOfDay(props.serverDay), getIndexOfDay(schEndD), getIndexOfDay(props.serverDay));
    props.durations.map((iterator) => {
      durationId = parseInt(iterator.durationId);
      layoutId = parseInt(schedule.layoutId);
      if (layoutId === durationId) {
        currentDuration = iterator
      }
    })

    if (!(localStorage.getItem('currentDuration'))) {
      localStorage.setItem('currentDuration', currentDuration.durationId)
    }

    return currentDuration
  }
}

export const hashCode = (element) => {
  let hash = 0, l = element.length, i = 0;
  if (l > 0) {
    while (i < l) {
      hash = (hash << 5) - hash + element.charCodeAt(i++) | 0;
    }
  }
  return hash;
}